<template>
    <v-container>
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card dark color="success" class="alineacentro DatosMatriculado">
                    <strong>LISTADO DE MATRICULADOS</strong>
                    <br/>
                    <strong class="TituloGrilla2">En la siguiente grilla encontrará el listado completo de los matriculados actuales. Por favor utilice los filtros para buscar por Nombre y Localidad.</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="3" lg="3">
                  <v-text-field
                    v-model="filtros.apenom"
                    label="Apellido y/o Nombre"
                    v-on:keyup.enter="actualizagrilla"
                  />
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-text-field
                    v-model="filtros.localidad"
                    label="Localidad"
                    v-on:keyup.enter="actualizagrilla"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-select
                    v-model="filtros.idespecialidad"
                    :items="listaespecialidades"
                    label="Especialidad"
                    item-text="nombre"
                    item-value="idtipoespecialidad"
                    v-on:change="actualizagrilla"
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="actualizagrilla"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="12" lg="12">
                  <v-data-table
                    :headers="columnas"
                    :items="lista"
                    :items-per-page="15"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="apenom"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialogmensaje = false; if(mensajehome===true){$router.push('Home')}">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "listamatriculados",
  components: {
    ConfirmDlg: ConfirmDlg,
  },
  data() {
    return {
      loading: false,
      usuario: "",
      permisolectura: false,
      permisoescritura: false,
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      filtros: {
        apenom: '',
        localidad: '',
        idespecialidad: 0
      },
      columnas: [
        {
            text: "Matriculado",
            align: "center",
            sortable: true,
            value: "apenom",
            width: 300
        },
        {
            text: "Abogado",
            align: "center",
            sortable: true,
            value: "abogado",
            width: 80
        },
        {
            text: "Procurador",
            align: "center",
            sortable: true,
            value: "procurador",
            width: 80
        },
        {
            text: "Domicilio",
            align: "center",
            sortable: true,
            value: "domicilio",
            width: 110
        },
        {
            text: "Localidad",
            align: "center",
            sortable: true,
            value: "localidad",
            width: 110
        },
        {
            text: "Tel. Fijo",
            align: "center",
            sortable: true,
            value: "telefono",
            width: 100
        },
        {
            text: "Celular",
            align: "center",
            sortable: true,
            value: "celular",
            width: 100
        },
        {
            text: "Correo",
            align: "center",
            sortable: true,
            value: "email",
            width: 200
        }
      ],
      lista: [],
      listaespecialidades: []
    };
  },
  mounted() {
    this.loading=true;
    axios.get("referenciales/especialidades").then((result) => {
      this.listaespecialidades= result.data;
      this.listaespecialidades.unshift({idtipoespecialidad: 0, nombre: '(TODAS)'});
      this.actualizagrilla();
    }).catch((error) => {
      this.loading = false;
      this.MostrarMensaje('Error', error, false);
    })
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    actualizagrilla () {
      this.loading=true;
      var filtro= JSON.stringify({apenom: this.filtros.apenom, localidad: this.filtros.localidad, idespecialidad: this.filtros.idespecialidad});
      axios.post("matriculado/PostListaMatriculadosPublico", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.lista = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    }
},
  computed: {
    /* fechalocalfcon: function () {
      if (this.edited.fecha != null && this.edited.fecha != "") {
        var fecha = new Date(this.edited.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }, */
  },
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.hide-toolbar .ql-toolbar {
    padding: 0;
    border-bottom: hidden;
    span {
        display: none;
    }
}

.ql-font-roboto {
  font-family: 'Roboto', sans-serif;
}

.editor {
    height: 40rem;
    overflow: hidden;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa10 {
  width: 10%;
}
.ocupa20 {
  width: 20%;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TextoDatoBold {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
}
.TextoDato {
  font-family: Tahoma;
  font-size: medium;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.TituloGrilla2 {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkseagreen;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>